<div class="video-container" data-cy="app-play-videos__play-video-container">
  <h2 mat-dialog-title class="modal-title">
    {{ data.title }}
    <button id="closeBtn" class="float-right" mat-icon-button (click)="close()">
      <mat-icon cdkFocusInitial matSuffix><span class="icon-shape cross"></span></mat-icon>
    </button>
  </h2>
  <app-videos [autoPlay]="autoPlay" [videoClosed]="videoClosed" [width]="700" [height]="520" [videoUrl]="data.url">
  </app-videos>

</div>